import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { fetchBalance, fetchBalanceByEmp, fetchBalanceByYear } from "src/api";
import { Constant } from "src/lib/Constants";

const { BALANCE_FETCH_SUCCESS, BALANCE_FETCH_ERROR, BALANCE_FETCH_LOADING, BALANCE_FETCH_BY_YEAR_LOADING, BALANCE_FETCH_BY_YEAR_SUCCESS, BALANCE_FETCH_BY_YEAR_ERROR, BALANCE_FETCH_BY_EMP_LOADING, BALANCE_FETCH_BY_EMP_SUCCESS, BALANCE_FETCH_BY_EMP_ERROR } = require("src/redux/types");

function* balanceFetch(action) {
    yield put({
      type: BALANCE_FETCH_LOADING,
      payload: true,
    });
    try {
      let res = yield call(fetchBalance);
      let response = res.response.data;
      if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
        yield put({
          type: BALANCE_FETCH_SUCCESS,
          payload: response.result,
        });
      } else {
        yield put({
          type: BALANCE_FETCH_ERROR,
          payload: response.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  function* balanceFetchByYear(action) {
    yield put({
      type: BALANCE_FETCH_BY_YEAR_LOADING,
      payload: true,
    });
    try {
      let res = yield call(fetchBalanceByYear,action.payload);
      let response = res.response.data;
      if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
        yield put({
          type: BALANCE_FETCH_BY_YEAR_SUCCESS,
          payload: response.result,
        });
      } else {
        yield put({
          type: BALANCE_FETCH_BY_YEAR_ERROR,
          payload: response.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  function* balanceFetchByEmp(action) {
    yield put({
      type: BALANCE_FETCH_BY_EMP_LOADING,
      payload: true,
    });
    try {
      let res = yield call(fetchBalanceByEmp,action.payload);
      let response = res.response.data;
      if (response.status === Constant.RESPONSE_STATUS.SUCCESS) {
        yield put({
          type: BALANCE_FETCH_BY_EMP_SUCCESS,
          payload: response.result,
        });
      } else {
        yield put({
          type: BALANCE_FETCH_BY_EMP_ERROR,
          payload: response.message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  export function* balanceSaga(){
    yield takeEvery("BALANCE_FETCH_ACTION",balanceFetch)
    yield takeLatest("BALANCE_FETCH_BY_YEAR_ACTION",balanceFetchByYear)
  yield takeLatest("BALANCE_FETCH_BY_EMP_ACTION",balanceFetchByEmp)
  }